module.exports = __webpack_public_path__ + "img/i1.d7da6eaf.svg";